import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';

@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}
  transform(url: string): SafeResourceUrl {
    
    if (url && (url.includes('.PDF'))) {
      const googleDocsViewerUrl = `https://docs.google.com/gview?url=${encodeURIComponent(url)}&embedded=true`;
      return this.sanitizer.bypassSecurityTrustResourceUrl(googleDocsViewerUrl);
    }
    
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
} 